import React, { useState, useEffect } from 'react'
import moment from 'moment'
import ProjectLoads from './ProjectLoads'

const Projects = props => {
  const [viewingLoads, setViewingLoads] = useState(false)
  const [currentProjectLoads, setCurrentProjectLoads] = useState()
  const [currentProjectName, setCurrentProjectName] = useState()

  const handleProjectPress = projectName => {
    setViewingLoads(true)
    setCurrentProjectLoads(
      props.activeNow.activeData.filter(item => item.haul.project.projectName === projectName)
    )
    setCurrentProjectName(projectName)
    props.history.push(`/app/active/projects/loads/`)
  }

  useEffect(() => {
    if (props.location.pathname === '/app/active/projects') {
      setViewingLoads(false)
      setCurrentProjectLoads(null)
      setCurrentProjectName(null)
    }
  }, [props.location.pathname])

  return viewingLoads ? (
    <div style={{ margin: '16px' }}>
      <ProjectLoads
        activeData={props.activeNow.activeData}
        currentProjectLoads={currentProjectLoads}
        currentProjectName={currentProjectName}
      />
    </div>
  ) : (
    <div style={{ margin: '16px' }}>
      <div>
        <span style={{ ccoclor: '#6B6C70', fontSize: '16px' }}>Active Now</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0 36px' }}>
        <span style={{ fontSize: '24px', color: '#3E3F42', fontWeight: '500' }}>
          {props.activeNow.projects.length +
            (props.activeNow.projects.length === 1 ? ' Project' : ' Projects')}
        </span>
        <span style={{ fontSize: '12px', alignSelf: 'flex-end' }}>
          Last updated {moment().format('HH:mm')}
        </span>
      </div>

      <div>
        {props.activeNow.projects.map((project, i) => {
          const loads = props.activeNow.activeData.filter(
            data => data.haul.project.projectName === project
          ).length
          const trucks = props.activeNow.signOnOffData.filter(item => item.projectName === project)
          const hauls = [...new Set(trucks)].length
          return (
            <div
              key={i}
              style={{
                height: '92px',
                boxShadow: '0px 1px 3px #00000029',
                borderRadius: '5px',
                marginTop: i > 0 ? '16px' : null
              }}
              onClick={() => handleProjectPress(project)}
            >
              <div
                style={{
                  backgroundColor: '#F6F9FD',
                  height: '35px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <span style={{ fontSize: '16px', color: '#3E3E41', paddingLeft: '16px' }}>
                  {project}
                </span>
              </div>
              <div style={{ display: 'flex', height: '52px' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '20%',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    borderRight: '1px solid #E7E7EC',
                    marginTop: '5px'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Loads</span>
                  <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                    {loads}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '20%',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    borderRight: '1px solid #E7E7EC',
                    marginTop: '5px'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Trucks</span>
                  <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                    {trucks.length}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    marginTop: '5px',
                    width: '50%'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Hauls</span>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-end'
                    }}
                  >
                    <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                      {hauls}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Projects
